import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-start text-xl font-bold" }, "Localização da unidade", -1)
const _hoisted_2 = { class: "mt-0.5 text-start text-sm text-gray-500" }
const _hoisted_3 = { class: "rounded-xl bg-[#EEF1F3] p-3 md:p-4" }
const _hoisted_4 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_5 = { class: "ml-auto flex flex-wrap items-center gap-2" }

import { computed, ref, toRef, watch } from 'vue'
import { mdiRestore } from '@mdi/js'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { MODAL_ACTION_HEIGHT } from '../../constants'
import type { UnitGeolocationApi } from '../../composables/useUnitGeolocation'
import { useUnitDoctorPoints } from '../../composables/useUnitDoctorPoints'
import PinStepHeader from './PinStepHeader.vue'
import StepFind from './StepFind.vue'
import StepPosition from './StepPosition.vue'
import StepConfirm from './StepConfirm.vue'
import type { PinModalMode, PinStep } from './pinModalTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitPinModal',
  props: {
    modalActive: { type: Boolean },
    geo: {},
    mode: {},
    unitName: {},
    registeredAddress: {},
    healthUnitId: {},
    initialStep: { default: 1 },
    isSaving: { type: Boolean, default: false }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;





const step = ref<PinStep>(props.initialStep)
const mapType = ref<'roadmap' | 'satellite'>('roadmap')

const doctor = useUnitDoctorPoints(toRef(props, 'healthUnitId'))

const SUBTITLES: Record<PinStep, string> = {
  1: 'Passo 1 de 3 — encontre o prédio da unidade pelo nome, como no Google Maps.',
  2: 'Passo 2 de 3 — posicione o marcador sobre o prédio e defina o raio.',
  3: 'Passo 3 de 3 — confira e salve.'
}

const subtitle = computed(() => SUBTITLES[step.value])

const canContinue = computed(() => {
  if (step.value === 1) return props.geo.foundLocation.value && !!props.geo.unitType.value
  return props.geo.canConfirm.value
})

function openAtInitialStep(): void {
  step.value = props.initialStep
  // O satélite é o que revela o prédio sob o marcador — o mapa comum esconde o erro.
  mapType.value = step.value >= 2 ? 'satellite' : 'roadmap'
  if (props.healthUnitId) doctor.load()
}

watch(
  () => props.modalActive,
  (isOpen) => isOpen && openAtInitialStep(),
  { immediate: true }
)

function goNext(): void {
  if (step.value === 3 || !canContinue.value) return
  step.value = (step.value + 1) as PinStep
  if (step.value === 2) mapType.value = 'satellite'
}

function goBack(): void {
  if (step.value === 1) return
  step.value = (step.value - 1) as PinStep
}

/** Sugestão da fila manda no alvo; sem ela, o centro da nuvem de checks. */
function centerOnDoctors(): void {
  if (props.geo.suggestedPoint.value) {
    props.geo.centerOnSuggestion()
    return
  }
  if (doctor.centroid.value) props.geo.updateCoordinates(doctor.centroid.value)
}

function save(): void {
  emit('confirm', props.geo.toConfirmPayload())
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    modalActive: _ctx.modalActive,
    "max-width": "max-w-5xl",
    "has-header-border": "",
    "has-footer-border": "",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('close')))
  }, {
    header: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", _hoisted_2, _toDisplayString(subtitle.value), 1),
      _createVNode(PinStepHeader, {
        class: "mt-3",
        step: step.value
      }, null, 8, ["step"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (step.value === 2 && _ctx.geo.canResetLocation.value)
          ? (_openBlock(), _createBlock(OutlinedButton, {
              key: 0,
              text: "Resetar localização",
              "prepend-icon": _unref(mdiRestore),
              width: "auto",
              height: _unref(MODAL_ACTION_HEIGHT),
              class: "!w-auto !px-4 text-sm",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.geo.resetLocation())),
              "data-testid": "pin-footer-reset-button"
            }, null, 8, ["prepend-icon", "height"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (step.value === 1)
            ? (_openBlock(), _createBlock(OutlinedButton, {
                key: 0,
                text: "Sair",
                width: "140px",
                height: _unref(MODAL_ACTION_HEIGHT),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close'))),
                "data-testid": "pin-exit-button"
              }, null, 8, ["height"]))
            : (_openBlock(), _createBlock(OutlinedButton, {
                key: 1,
                text: "Voltar",
                width: "140px",
                height: _unref(MODAL_ACTION_HEIGHT),
                onClick: goBack,
                "data-testid": "pin-back-button"
              }, null, 8, ["height"])),
          (step.value < 3)
            ? (_openBlock(), _createBlock(FilledButton, {
                key: 2,
                text: "Continuar",
                width: "200px",
                height: _unref(MODAL_ACTION_HEIGHT),
                disabled: !canContinue.value,
                onClick: goNext,
                "data-testid": "pin-continue-button"
              }, null, 8, ["height", "disabled"]))
            : (_openBlock(), _createBlock(FilledButton, {
                key: 3,
                text: "Salvar pino",
                width: "200px",
                height: _unref(MODAL_ACTION_HEIGHT),
                disabled: !_ctx.geo.canSave.value,
                loading: _ctx.isSaving,
                onClick: save,
                "data-testid": "pin-save-button"
              }, null, 8, ["height", "disabled", "loading"]))
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (step.value === 1)
          ? (_openBlock(), _createBlock(StepFind, {
              key: 0,
              geo: _ctx.geo,
              "registered-address": _ctx.registeredAddress,
              onNext: goNext
            }, null, 8, ["geo", "registered-address"]))
          : (step.value === 2)
            ? (_openBlock(), _createBlock(StepPosition, {
                key: 1,
                geo: _ctx.geo,
                "map-type": mapType.value,
                "doctor-points": _unref(doctor).points.value,
                "doctor-summary": _unref(doctor).summary.value,
                "is-loading-points": _unref(doctor).isLoading.value,
                "onUpdate:mapType": _cache[0] || (_cache[0] = ($event: any) => (mapType.value = $event)),
                onCenterDoctors: centerOnDoctors
              }, null, 8, ["geo", "map-type", "doctor-points", "doctor-summary", "is-loading-points"]))
            : (_openBlock(), _createBlock(StepConfirm, {
                key: 2,
                geo: _ctx.geo,
                "unit-name": _ctx.unitName,
                "map-type": mapType.value,
                "doctor-summary": _unref(doctor).summary.value,
                mode: _ctx.mode
              }, null, 8, ["geo", "unit-name", "map-type", "doctor-summary", "mode"]))
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})